import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { ProfileUserInfoModel } from '@app/models/failure/user.model';

@Injectable({ providedIn: 'root' })
export class ProfileService {

  private graphApi = `https://graph.microsoft.com/v1.0/me`;
  private apiUrlRedis = `${environment.apiUrl}/api/redis/`;

  constructor(private httpClient: HttpClient) { }

  getProfile(): Observable<ProfileUserInfoModel> {
    return this.httpClient.get<ProfileUserInfoModel>(`${this.graphApi}`);
  }
  
  getProfileImage(accessToken: string): Observable<Blob> {
    let headers = new HttpHeaders()
      .set('Content-Type', 'image/jpeg')
      .set('Authorization', `Bearer ${accessToken}`);
    return this.httpClient.get(`${this.graphApi}/photo/$value`, { headers, responseType: 'blob' });
  }

  getActiveDirectoryUsers(searchValue: string): Observable<any[]> {
    return this.httpClient.get<any[]>(`${this.graphApi}/people/?$search=${searchValue}`);
  }

  getUsersList(searchValue: string): Observable<any[]> {
    let headers = new HttpHeaders().set('Content-Type', 'applocation/json');
    return this.httpClient.get<any[]>(`${this.apiUrlRedis}get?key=people`, { headers });
  }

}
